import Logo from "@/components/global/Logo";
import { Mail, MapPin, PhoneCall } from "lucide-react";

import { faWhatsapp, faYoutube, faLinkedin, faTiktok, faFacebook, faInstagram  } from "@fortawesome/free-brands-svg-icons";

export const footer = {
  logo: <Logo />,
  summary:
    "Somos el aliado estratégico en asesoría y consultoría relacionados con la actividad financiera, contable y tecnológica, para ayudarte con el crecimiento de tu empresa.",
  contacts: [
    {
      label: "+51 937 712 155",
      icon: PhoneCall,
    },
    {
      label: "+51 980 710 030",
      icon: PhoneCall,
    },
    {
      label: "informes@siconsperu.com",
      icon: Mail,
    },
    {
      label: "Calle FERMIN TANGUIS Nº 160 URB. SANTA CATALINA LIMA - LIMA - LA VICTORIA",
      icon: MapPin,
    },
  ],
  navigation: [
    {
      title: "ERP CIGE Perú",
      links: [
        {
          title: "CIGE - ERP",
          path: "/erpcige/cigeerp",
        },
        {
          title: "CIGE - FI",
          path: "/erpcige/cigefi",
        },
        {
          title: "CIGE - CPE",
          path: "/erpcige/cigecpe",
        },
        {
          title: "CIGE - Planillas",
          path: "/erpcige/cigeplanillas",
        },
      ],
    },
  
    {
      title: "Servicios",
      links: [
        {
          title: "Outsourcing Contable",
          path: "/services",
        },
        {
          title: "Outsourcing Laboral",
          path: "/services",
        },
        {
          title: "Outsourcing Tributario",
          path: "/services",
        }
      ],
    },

    {
      title: "Soluciones TI",
      links: [
        {
          title: "Microsoft Office",
          path: "/itsolutions/microsoftoffice",
        },
        {
          title: "Certificado Digital FE",
          path: "/itsolutions/fedigitalcertificate"
        }
      ],
    },

  ],

socialMedia: [
    {
      name: "whatsapp",
      url: "https://wa.me/51937712155?text=Hola,%20necesito%20ayuda",
      icon: faWhatsapp,
    },
    {
      name: "youtube",
      url: "https://www.youtube.com/@siconsperu",
      icon: faYoutube,
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/company/siconsperu",
      icon: faLinkedin,
    },

  {
      name: "facebook",
      url: "https://www.facebook.com/siconsperu",
      icon: faFacebook,
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/siconsperu/",
      icon: faInstagram,
    },
    {
      name: "tiktok",
      url: "https://www.tiktok.com/@siconsperu",
      icon: faTiktok,
    },
  ],

};
